import { faChevronDown, faChevronUp, faSync, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

function NewVersionToast() {
	const { t } = useTranslation(undefined, { useSuspense: false });
	const [minimized, setMinimized] = useState(false);

	return (
		<div className="nvt">
			<div className="nvt__header">
				<div className="nvt__icon">
					<FontAwesomeIcon icon={faSync} />
				</div>
				<span className="nvt__title">{t("new-version.title")}</span>
				<div className="nvt__actions">
					<button
						type="button"
						className="nvt__btn-icon"
						onClick={() => setMinimized((m) => !m)}
						aria-label={minimized ? "Expand" : "Minimize"}
					>
						<FontAwesomeIcon icon={minimized ? faChevronUp : faChevronDown} />
					</button>
					<button
						type="button"
						className="nvt__btn-icon"
						onClick={() => toast.dismiss("new-version")}
						aria-label={t("new-version.dismiss")}
					>
						<FontAwesomeIcon icon={faTimes} />
					</button>
				</div>
			</div>
			{!minimized && (
				<div className="nvt__body">
					<p className="nvt__message">{t("new-version.message")}</p>
					<Button
						variant="dark"
						size="sm"
						className="nvt__refresh-btn"
						onClick={() => setTimeout(() => window.location.reload(), 0)}
					>
						{t("new-version.refresh")}
					</Button>
				</div>
			)}
		</div>
	);
}

export default NewVersionToast;
